/**
 * @generated SignedSource<<4886245883433a78bf593c6044a2a2aa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShopBreadcrumbs_landingPage$data = {
  readonly title: string | null;
  readonly " $fragmentType": "ShopBreadcrumbs_landingPage";
};
export type ShopBreadcrumbs_landingPage$key = {
  readonly " $data"?: ShopBreadcrumbs_landingPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShopBreadcrumbs_landingPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShopBreadcrumbs_landingPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "LandingPage",
  "abstractKey": null
};

(node as any).hash = "737f14e41dae051207ffadd92a2fda81";

export default node;
